import {useMemo} from 'react';
import {useSelector} from 'react-redux';

const selectCategories = state => state.categories;
export function useCategories() {
    return useSelector(selectCategories);
}

export function useCategory(id) {
    const categories = useCategories();
    return useMemo(() => {
        return categories.find(cat => cat.id == id);
    }, [categories, id]);
}

export function useField(categoryId, fieldName) {
    const category = useCategory(categoryId);
    return useMemo(() => {
        return category?.fields.find(field => field.name == fieldName);
    }, [category, fieldName]);
}

export function useOperator(categoryId, fieldName, operatorId) {
    const field = useField(categoryId, fieldName);
    return useMemo(() => {
        return field?.operators.find(op => op.id == operatorId);
    }, [field, operatorId]);
}
